// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class MixSummary {
  readonly id: string;
  readonly alternateId: string;
  readonly name: string;
  readonly strength: string;
  readonly strengthUnit: Enums.Unit;
  readonly materialCost: string;
  readonly plantName: string;
  readonly incompatibleQuantityUnits: string | null;
  readonly slump: string | null;
  readonly aggregateSize: string | null;
  readonly waterCementPercentage: string | null;
  readonly flyAshPercentage: string | null;
  readonly plantId: string;
  readonly marketId: string;
  readonly externalId: string | null;
  readonly category: Enums.MixCategory;
  readonly isArchived: boolean;
  readonly divisionId: string | null;
  readonly plantIsArchived: boolean;
  readonly currencyCode: Enums.CurrencyCode;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.alternateId = data.alternateId === undefined ? '' : data.alternateId;
    this.name = data.name === undefined ? '' : data.name;
    this.strength = data.strength === undefined ? '' : data.strength;
    this.strengthUnit = data.strengthUnit === undefined ? Enums.Unit.Psi : data.strengthUnit;
    this.materialCost = data.materialCost === undefined ? '' : data.materialCost;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.incompatibleQuantityUnits =
      (data.incompatibleBatchUnits ?? data.incompatibleQuantityUnits) === undefined
        ? null
        : (data.incompatibleBatchUnits ?? data.incompatibleQuantityUnits);
    this.slump = data.slump === undefined ? null : data.slump;
    this.aggregateSize = data.aggregateSize === undefined ? null : data.aggregateSize;
    this.waterCementPercentage =
      data.waterCementPercentage === undefined ? null : data.waterCementPercentage;
    this.flyAshPercentage = data.flyAshPercentage === undefined ? null : data.flyAshPercentage;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.externalId = data.externalId === undefined ? null : data.externalId;
    this.category = data.category === undefined ? Enums.MixCategory.ReadyMix : data.category;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
    this.currencyCode =
      data.currencyCode === undefined ? Enums.CurrencyCode.USD : data.currencyCode;
  }

  static zero(): MixSummary {
    const zeroValues: ExcludeMethodsDeep<MixSummary> = {
      id: NIL_UUID,
      alternateId: '',
      name: '',
      strength: '',
      strengthUnit: Enums.Unit.Psi,
      materialCost: '',
      plantName: '',
      incompatibleQuantityUnits: null,
      slump: null,
      aggregateSize: null,
      waterCementPercentage: null,
      flyAshPercentage: null,
      plantId: NIL_UUID,
      marketId: NIL_UUID,
      externalId: null,
      category: Enums.MixCategory.ReadyMix,
      isArchived: false,
      divisionId: null,
      plantIsArchived: false,
      currencyCode: Enums.CurrencyCode.USD,
    };
    return new MixSummary(zeroValues);
  }

  toJSON(): { [key: string]: any } {
    return {
      id: this.id,
      alternateId: this.alternateId,
      name: this.name,
      strength: this.strength,
      strengthUnit: this.strengthUnit,
      materialCost: this.materialCost,
      plantName: this.plantName,
      incompatibleBatchUnits: this.incompatibleQuantityUnits,
      slump: this.slump,
      aggregateSize: this.aggregateSize,
      waterCementPercentage: this.waterCementPercentage,
      flyAshPercentage: this.flyAshPercentage,
      plantId: this.plantId,
      marketId: this.marketId,
      externalId: this.externalId,
      category: this.category,
      isArchived: this.isArchived,
      divisionId: this.divisionId,
      plantIsArchived: this.plantIsArchived,
      currencyCode: this.currencyCode,
    };
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MixSummaryWireFormat = {
  id: string;
  alternateId: string;
  name: string;
  strength: string;
  strengthUnit: string;
  materialCost: string;
  plantName: string;
  incompatibleQuantityUnits: string | null;
  slump: string | null;
  aggregateSize: string | null;
  waterCementPercentage: string | null;
  flyAshPercentage: string | null;
  plantId: string;
  marketId: string;
  externalId: string | null;
  category: string;
  isArchived: boolean;
  divisionId: string | null;
  plantIsArchived: boolean;
  currencyCode: string;
};

type NewMixSummaryProps = PartialDeep<MixSummary, { recurseIntoArrays: true }>;
export const NewMixSummary: (props: NewMixSummaryProps) => MixSummary = (props) =>
  new MixSummary(props);

type NewMixSummaryFromWireFormatProps = PartialDeep<
  MixSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMixSummaryFromWireFormat: (
  props: NewMixSummaryFromWireFormatProps,
) => MixSummary = (props) => new MixSummary(props);
